import {
  DataTableFilterMeta,
  DataTableFilterMetaData,
} from "primevue/datatable"
import { FilterMatchMode, FilterOperator } from "primevue/api"
import { ref, computed } from "vue"
import { IProfissionais } from "@/types/profissionais"

export function tabelaProfissionais(profissionais: IProfissionais[]) {
  const filtros = ref<DataTableFilterMeta | undefined>({
    id: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ] as DataTableFilterMetaData[],
    },
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ] as DataTableFilterMetaData[],
    },
    categoria: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ] as DataTableFilterMetaData[],
    },
  })

  const profissionaisOrdenadosPorStatus = computed(() => {
    return ordenarProfissionaisPorStatus(profissionais)
  })
  const ordenarProfissionaisPorStatus = (
    projetos: IProfissionais[]
  ): IProfissionais[] => {
    return profissionais.sort(
      (a: IProfissionais, b: IProfissionais): number => -(+a.nome - +b.nome)
    )
  }
  const desativarLinhaPorStatus = (data: any): string | undefined => {
    return !data.status ? "row-disabled" : undefined
  }

  return {
    filtros,
    profissionaisOrdenadosPorStatus,
    desativarLinhaPorStatus,
  }
}
